import { Box, Text } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { handleResponseLanguage } from '../../../../../i18n';
import { ErrorLouiseOffer } from '../../../../../types/Quotes';
import QuoteErrorMessage from '../default/QuoteErrorMessage';
import { RootState } from '../../store/redux/reducers/rootReducer';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

interface Props {
  offer: ErrorLouiseOffer;
}

const SingleOfferErrorMessage: React.FC<React.PropsWithChildren<Props>> = ({
  offer,
}) => {
  const { t } = useTranslation();

  const offerCombinationError = useSelector(
    (state: RootState) =>
      state.offers.offersInfo.offerCombinationError[offer.hash_id],
  );

  return (
    <Box
      mt={isSocialLoginUrl ? '2' : '10'}
      mb="2"
      mx={{ base: '2', laptop: '6' }}
    >
      {offerCombinationError ? (
        <Text color="danger.main" mb="0" textAlign="center">
          {t('The combination of the options you provided is not supported')}
        </Text>
      ) : (
        <QuoteErrorMessage
          httpCode={offer.code}
          message={handleResponseLanguage(offer.errorMessage)}
        />
      )}
    </Box>
  );
};

export default SingleOfferErrorMessage;
